import { Grid, Paper } from "@mui/material";
import MDAlert from "components/MDAlert";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TableSkeleton from "components/TableSkeleton/TableSkeleton";
import useGetOrganizationProposalChecklistItems from "hooks/organization/useGetOrganizationProposalChecklistItems";
import ChecklistItemItem from "./ChecklistItemItem";
import CreateChecklistItem from "./CreateChecklistItem";

export default function ChecklistItemsList() {
  const { loading, error, data } = useGetOrganizationProposalChecklistItems();

  return (
    <Paper sx={{ p: "25px", mb: "20px" }}>
      <MDBox>
        <MDBox mb={3} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h5" fontWeight="medium">
            Proposal Checklist Items
          </MDTypography>
          <CreateChecklistItem />
        </MDBox>
        {loading && <TableSkeleton numberOfLines={5} />}
        {error && <MDAlert color="error">{error.message}</MDAlert>}
        {!loading &&
          !error &&
          (data.length === 0 ? (
            <MDTypography variant="body2" color="text" ml={2}>
              No checklist items found.
            </MDTypography>
          ) : (
            <Grid container>
              {data.map((item, index) => (
                <Grid
                  item
                  xs={6}
                  key={item.id}
                  sx={{
                    borderRight: index % 2 === 0 ? "1px solid #eee" : "none",
                    pr: index % 2 === 0 ? 3 : 0,
                    pl: index % 2 === 1 ? 3 : 0,
                  }}
                >
                  <ChecklistItemItem item={item} />
                </Grid>
              ))}
            </Grid>
          ))}
      </MDBox>
    </Paper>
  );
}
